var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMulti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7251 2.3178L12.8269 1.94243V7.9953L14.4558 4.0673C14.7306 3.38359 14.4155 2.59933 13.7251 2.3178ZM0.654128 4.79794L3.97885 12.8081C4.07675 13.0518 4.24375 13.2616 4.4593 13.4117C4.67486 13.5617 4.92957 13.6455 5.19211 13.6527C5.36639 13.6527 5.54737 13.6192 5.72165 13.5454L10.6618 11.501C11.1645 11.2932 11.4729 10.7972 11.4863 10.3012C11.493 10.1269 11.4595 9.93249 11.3992 9.75821L8.04762 1.74804C7.95319 1.50251 7.78687 1.29119 7.57041 1.1417C7.35395 0.992207 7.09742 0.91151 6.83436 0.910156C6.66008 0.910156 6.4858 0.950375 6.31822 1.0107L1.38476 3.05514C1.05682 3.18943 0.795638 3.44846 0.658627 3.77527C0.521617 4.10209 0.519999 4.46993 0.654128 4.79794ZM11.4796 2.25077C11.4796 1.89522 11.3383 1.55423 11.0869 1.30281C10.8355 1.0514 10.4945 0.910156 10.139 0.910156H9.16703L11.4796 6.50052",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMulti);
export default __webpack_public_path__ + "static/media/multi.dd045a59f18f5881d274867cf76860fb.svg";
export { ForwardRef as ReactComponent };